// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import rtlDetect from 'rtl-detect';
import { TranslationService } from '../../../services';
// Styles
import * as styles from '../NoteInput.scss';

export default class FormattedNote extends Component {
  componentDidMount() {
    this.note.innerHTML = this.props.content;
    setTimeout(this.checkNoteLanguage);
  }

  componentWillReceiveProps({ content }) {
    if (this.props.content !== content) {
      this.note.innerHTML = content;
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  setNoteDirection = ({ language }) => {
    if (!language) {
      return;
    }

    this.note.classList.add(rtlDetect.getLangDir(language));
  };

  checkNoteLanguage = () => {
    this.note && TranslationService
      .suggestStringLanguage(this.note.textContent)
      .then(this.setNoteDirection);
  };

  render() {
    return (
      <div className={styles.noteContent} ref={(note) => { this.note = note; }} />
    );
  }
}

FormattedNote.propTypes = {
  content: PropTypes.string
};
